module.exports = __webpack_public_path__ + "static/media/logo-external-retina.87c9a7c1.png";